/* eslint-disable @typescript-eslint/indent */
import {
  CoverageWithMeta,
  CoverageWithMetaMap,
  CoveragesDetails,
} from '../Coverage.type';
import { createCoverageMap } from './meta';

export const selectCoverage = (
  coverage: CoverageWithMeta,
  selected: boolean,
): CoverageWithMeta => ({
  ...coverage,
  coverage: {
    ...coverage.coverage,
    selected,
  },
});

export const toggleCoverage = (
  coverage: CoverageWithMeta,
): CoverageWithMeta => {
  const isSelected = coverage.coverage.selected;

  return selectCoverage(coverage, !isSelected);
};

export const areAllTriggersSelected = (
  triggerList: string[],
  coveragesMap: CoverageWithMetaMap,
): boolean => triggerList.every((triggerKey) => {
  const triggeredCoverage = coveragesMap.get(triggerKey);

  return triggeredCoverage?.coverage.selected;
});

export const toggleCoverageWitAffected = (
  toggledCoverage: CoverageWithMeta,
  coverages: CoverageWithMeta[],
): CoverageWithMeta[] => {
  const coveragesMap = createCoverageMap(coverages);
  const toggledCoverageCode = toggledCoverage.codeIdentifier;
  const affectedCoverageCodes = coverages
    .filter((coverage) => coverage?.triggeredBy?.includes(toggledCoverageCode))
    .map((coverage) => coverage.codeIdentifier);

  coveragesMap.set(toggledCoverageCode, toggleCoverage(toggledCoverage));

  return [...coveragesMap.entries()].map(([codeIdentifier, coverage]) => {
    if (
      affectedCoverageCodes.includes(codeIdentifier)
      && coverage.triggeredBy
    ) {
      const isSelected = areAllTriggersSelected(
        coverage.triggeredBy,
        coveragesMap,
      );

      return selectCoverage(coverage, isSelected);
    }

    return coverage;
  });
};

export const replaceCoverageWithMetaByName = (
  coverages: CoverageWithMeta[],
  coverage: CoverageWithMeta,
): CoverageWithMeta[] => coverages.map((currentCoverage) => {
  if (currentCoverage.name === coverage.name) {
    return coverage;
  }

  return currentCoverage;
});

export const filterSelectedCoveragesByName = (
  coverages: CoverageWithMeta[],
  coveragesDetails: CoveragesDetails,
) => coverages
  .filter(
    ({ codeIdentifier, coverage, fake }) => coverage.selected && (!!coveragesDetails[codeIdentifier] || !fake),
  )
  .reduce<CoverageWithMeta[]>((accCoverages, currentCoverage) => {
    const isIncludedName = accCoverages.some(
      ({ name }) => name === currentCoverage.name,
    );
    const hasModalDetails = !!coveragesDetails[currentCoverage.codeIdentifier];

    if (!isIncludedName) {
      return [...accCoverages, currentCoverage];
    }

    if (isIncludedName && hasModalDetails) {
      return replaceCoverageWithMetaByName(accCoverages, currentCoverage);
    }

    return accCoverages;
  }, [])
  .sort(
    (prev, next) => (prev?.displayOrder ?? Infinity) - (next?.displayOrder ?? Infinity),
  );
